<template>
  <div class="login">
    <div class="loginC">
      <div class="loginCO">
        <p class="loginCOtit">绑定手机号</p>
        <div class="loginCOF">
          <div class="loginCOI">
            <img src="static/images/login1.png"  alt class="loginCOIimg"/>
            <div class="loginCOIR">
              <input type="text" onkeyup="this.value=this.value.replace(/\D/g,'')" maxlength="11"  v-model="phoneNumber" placeholder="输入手机号" class="loginCOIRinput"/>
            </div>
            <div class="clear"></div>
          </div>
          <div class="loginCOI">
            <img src="static/images/login2.png"  alt class="loginCOIimg loginCOIimg1"/>
            <div class="loginCOIR">
              <input type="text" onkeyup="this.value=this.value.replace(/\D/g,'')" maxlength="6" v-model="code" placeholder="输入验证码" class="loginCOIRinput"/>
              <p class="loginCOIRbtn" v-show="show" @click="getCode">获取验证码</p>
              <p class="loginCOIRbtn" v-show="!show">{{count}}s再获取</p>
            </div>
            <div class="clear"></div>
          </div>
          <!--<div class="loginCOB">
            <van-checkbox v-model="checked">我已阅读并同意<em>《注册服务协议》</em></van-checkbox>
          </div> -->
        </div>
        <div class="loginCObtn">
          <button @click="cancle">取消</button>
          <button @click="bindingTel">绑定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getTestToken, sendCodeMessage, bindingTel} from "../api/api"
import { Toast } from "vant";
export default {
  name: 'login',
  data () {
    return {
      checked: true,
      show: true,
      count: '',
      timer: null,
      phoneNumber: null,
      code: null,
      obdtk: null,
      userinfo: {} 
    }
  },
  mounted() {
  },
  methods: {
    getCode(){
      const TIME_COUNT = 30;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = true;
        if (!this.phoneNumber) {
          Toast('手机号不能为空');
          return
        }
        // 获取验证码
        sendCodeMessage(this, {phoneNumber: this.phoneNumber}).then(res => {
          if(res.code == 200) {
            Toast(res.msg);
          }
        })
        this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT && this.phoneNumber != null) {
          this.show = false;
          this.count--;
          } else {
          this.show = true;
          clearInterval(this.timer);
          this.timer = null;
          }
        }, 1000)
      }
    },
    cancle () {
      this.$router.push("/mine")
    },
    bindingTel (){
      console.log(this.phoneNumber)
        if (!this.phoneNumber) {
          Toast('手机号不能为空');
          return false
        }
        if (!this.code) {
          Toast('验证码不能为空');
          return
        }
        if (!this.checked) {
          Toast('注册服务协议必须选择');
          return
        }
        bindingTel(this, {phoneNumber: this.phoneNumber, code: this.code}).then(res => {
          if (res.code == 200) {
            sessionStorage.setItem("userinfo", JSON.stringify(res.data.userInfo))
            this.$router.push("/mine")
          }else {
             Toast(res.msg);
          }
        })       
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  

</style>



// WEBPACK FOOTER //
// src/components/login.vue